import { render, staticRenderFns } from "./Conyuge.vue?vue&type=template&id=69548724&scoped=true&"
import script from "./Conyuge.vue?vue&type=script&lang=js&"
export * from "./Conyuge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69548724",
  null
  
)

export default component.exports